import React from 'react';
import PropTypes from 'prop-types';

import { vehicleImageUrl } from '../../library/fitment/fitment-utils';

import './vehicle-image.scss';

function VehicleImage(props) {
  const {
    alt = '',
    className,
    height,
    smallImageUrl = null,
    vehicleType,
    width
  } = props;

  const imgSrc = vehicleImageUrl(smallImageUrl, vehicleType);

  return (
    <div
      className={`${className || ''} vehicle-image`}
      styleName="vehicle-display image"
    >
      <img alt={alt} height={height} src={imgSrc} width={width} />
    </div>
  );
}
VehicleImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string,
  smallImageUrl: PropTypes.string,
  vehicleType: PropTypes.string,
  width: PropTypes.string
};

export default VehicleImage;
